// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { RadioGroup, FormHelperText, RadioGroupProps, Stack, Paper, Box } from '@mui/material';
import { ReactNode } from 'react';

// ----------------------------------------------------------------------

type Props = RadioGroupProps & {
  name: string;
  label?: string;
  options: {
    label: string | ReactNode;
    value: any;
    disabled?: boolean;
  }[];
};

export default function RHFReaction({ name, label, options, ...other }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState: { error } }) => (
        <div>
          <RadioGroup {...field} row {...other}>
            <Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1}>
              {options.map((item, index) => (
                <Stack
                  className={field.value === item.value ? 'reaction-box' : ''}
                  key={index}
                  onClick={() => {
                    field.onChange(item.value);
                  }}
                >
                  <Box
                    component="img"
                    src={`/assets/reaction/${item.value.toLocaleLowerCase()}.svg`}
                    sx={{
                      m: 1,
                      display: 'flex',
                      width: field.value === item.value ? 40 : 30,
                      height: field.value === item.value ? 40 : 30,
                    }}
                  />
                </Stack>
              ))}
            </Stack>
          </RadioGroup>

          {!!error && (
            <FormHelperText error sx={{ px: 2 }}>
              {error.message}
            </FormHelperText>
          )}
        </div>
      )}
    />
  );
}
